import cx from "classnames";
import type { Element } from "React";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { TranslationHelper } from "../../helpers/translationHelper";
import type { EventIncidentType } from "../../types/eventType";
import "./DangerZoneTextOnly.scss";
type Props = {
  eventIncident: EventIncidentType;
  className?: string;
  incidentType: any;
  dangerZoneState: string;
  possibleVar: boolean;
  isHome: boolean;
  isAway: boolean;
};

class DangerZoneTextOnly extends Component<Props> {
  render(): Element<"div"> {
    const {
      className,
      incidentType,
      dangerZoneState,
      possibleVar,
      isHome,
      isAway,
    } = this.props;
    return (
      <div
        className={cx(
          `danger-zone-text ${className !== undefined ? className : ""}`,
          {
            "is-home": isHome,
            "is-away": isAway,
            "possible-var": possibleVar,
          }
        )}
      >
        {/* BET-5712 possible var event incident has no particapant id so no side is returned from API */}
        {possibleVar && (
          <FormattedMessage
            tagName="span"
            id={TranslationHelper.getTranslationIdForDangerZone(
              dangerZoneState
            )}
          />
        )}
        {isHome && (
          <FormattedMessage
            tagName="span"
            id={
              incidentType === null
                ? TranslationHelper.getTranslationIdForDangerZone(
                    dangerZoneState
                  )
                : TranslationHelper.getTranslationIdForIncidentType(
                    incidentType
                  )
            }
          />
        )}
        {isAway && (
          <FormattedMessage
            tagName="span"
            id={
              incidentType === null
                ? TranslationHelper.getTranslationIdForDangerZone(
                    dangerZoneState
                  )
                : TranslationHelper.getTranslationIdForIncidentType(
                    incidentType
                  )
            }
          />
        )}
      </div>
    );
  }
}

export default DangerZoneTextOnly;
